var o = "_icon_1q1xv_1",
  c = "_copyBtn_lusj3_3",
  n = "_hide_lusj3_26",
  _ = "_preloadTickIcon_lusj3_30",
  s = {
    icon: o,
    copyBtn: c,
    hide: n,
    preloadTickIcon: _
  };
export { c as copyBtn, s as default, n as hide, o as icon, _ as preloadTickIcon };